import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { assets } from "@/lib/assets";

const links = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Founder", href: "#founder" },
  { label: "Why KAT", href: "#why" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-slate-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="kat-container flex items-center justify-between h-24 md:h-28">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-4 kat-focus"
          aria-label="KAT Consulting & Branding — home"
        >
          <img
            src={assets.logo}
            alt="KAT Consulting & Branding logo"
            className="h-16 w-16 md:h-20 md:w-20 object-contain rounded-sm bg-white p-1"
          />
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-2xl md:text-3xl text-[color:var(--kat-navy)]">KAT</span>
            <span className="text-[10px] md:text-[11px] tracking-[0.28em] uppercase text-[color:var(--kat-muted)] font-medium">
              Consulting & Branding
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="nav-link text-sm font-medium text-[color:var(--kat-navy)] hover:text-[color:var(--kat-sky-deep)] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="nav-cta-consult"
            className="hidden md:inline-flex items-center gap-2 bg-[color:var(--kat-navy)] hover:bg-[color:var(--kat-navy-2)] text-white text-sm font-medium px-6 py-3 rounded-sm transition-colors kat-focus"
          >
            Book a Consultation
            <span aria-hidden>→</span>
          </a>
          <button
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
            className="lg:hidden inline-flex items-center justify-center w-11 h-11 rounded-sm border border-slate-300 text-[color:var(--kat-navy)] kat-focus"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div
          className="lg:hidden bg-white border-t border-slate-200"
          data-testid="mobile-menu-drawer"
        >
          <div className="kat-container py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-base font-medium text-[color:var(--kat-navy)]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta"
              className="mt-2 inline-flex items-center justify-center bg-[color:var(--kat-navy)] text-white px-6 py-3 rounded-sm text-sm font-medium"
            >
              Book a Consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
